import React, {Component} from "react"
import PropTypes from "prop-types"
import {get, isEqual} from "lodash"

import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import {Radio} from "@irati/ui/src/FormItem"
import {PERIOD_VALUE_PROPERTY} from "@irati-web/fields/schedule"

export const PROPERTY = "preferences.questionCount"

export const schema = (props, required) => {
  return Validation.number(required ? props.formatMessage({id: "insights.validation.required"}) : null)
}

class QuestionCount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      options: this.listOptions(this.determineNumberOfQuestions())
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.schedule, prevProps.schedule)) {
      this.updateOptions()
    }
  }

  listOptions = (options) => {
    return options.map((option) => {
      return {
        label: this.props.formatMessage({id: `insights.fields.schedule.questionCount.${option}.questions`}),
        value: option
      }
    })
  }

  updateOptions = () => {
    this.setState({
      options: this.listOptions(this.determineNumberOfQuestions())
    })
  }

  handleCountChange = (questionCountValue) => {
    const {onChange, schedule, name} = this.props
    onChange(schedule, name, questionCountValue)
  }

  handleChange = (value) => {
    const {onChange, schedule, name} = this.props
    onChange(schedule, name, value.value)
  }

  determineNumberOfQuestions = () => {
    const {schedule} = this.props
    const selectedFrequency = get(schedule, PERIOD_VALUE_PROPERTY)
    switch (selectedFrequency) {
      case 2:
        return [5, 10]
      case 4:
        return [10, 15]
      case 1:
      default:
        return [5]
    }
  }

  render() {
    const idNamespace = id("QuestionCount", this.props)
    const {schedule, name, disabled, formatMessage} = this.props
    const {options} = this.state
    const value = schedule.preferences.questionCount
    const radioLabel = formatMessage({id: "insights.fields.schedule.questionCount.label"})

    return (
      <>
        <Radio
          label={radioLabel}
          disabled={disabled}
          id={id("radio", idNamespace)}
          name={name}
          value={value}
          onChange={this.handleCountChange}
          options={options} />
      </>
    )
  }
}

QuestionCount.propTypes = {
  intl: PropTypes.object.isRequired,
  schedule: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  validation: PropTypes.object,
  name: PropTypes.string,
  formatMessage: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

QuestionCount.defaultProps = {
  required: true,
  validation: null,
  name: PROPERTY,
  disabled: false
}

export default injectIntl(QuestionCount)
